import { FC, ReactNode, useCallback, useEffect, useState } from "react";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

interface TabLayoutProps {
  tabNames: string[]
  tabIcons?: IconDefinition[]
  tabContents?: ReactNode[]
  activeTab?: string
  setActiveTab?: (tabName: string) => void
}

export const TabLayout: FC<TabLayoutProps> = props => {
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    if (props.activeTab) {
      setActiveTab(props.tabNames.indexOf(props.activeTab))
    }
  }, [props.tabNames, props.activeTab])

  const selectTab = useCallback((index: number) => {
    if (props.setActiveTab) {
      props.setActiveTab(props.tabNames[index])
    } else {
      setActiveTab(index)
    }
  }, [props.setActiveTab, props.tabNames])

  return <div>
    <ul className={"flex space-x-2 my-4"}>
      {props.tabNames.map((tabName, index) => {
        return <li key={index}>
          <button type={"button"} onClick={() => selectTab(index)} className={`h-8 text-sm rounded-lg font-medium flex items-center px-3 border ${index === activeTab ? 'bg-brand-100 text-brand-900 border-brand-500' : 'bg-slate-100 hover:bg-slate-200 cursor-pointer text-slate-900 border-transparent'}`}>
            {tabName}
          </button>
        </li>
      })}
    </ul>
    {props.tabContents !== undefined && <>
      {props.tabContents[activeTab]}
    </>}
  </div>
}
